import { formatClock } from "./format.ts"
import { replayEnd } from "./accounts.ts"
import { syncChartPreference, useAccounts, useAccountState, useSyncChart } from "./tradingData.ts"

/** Marks a chart that stops at a replay account's virtual time (and turns that off). */
export function ReplayBadge() {
  const state = useAccountState()
  const accounts = useAccounts()
  const sync = useSyncChart()
  const end = replayEnd(state, accounts, sync)
  if (end === null) return null
  return (
    <button
      type="button"
      className="pane-source pane-replay"
      title="This chart stops at the paper account's replay time, so it never shows the future. Click to show every bar."
      onClick={() => syncChartPreference.set("off")}
    >
      Replay · {formatClock(end)}
    </button>
  )
}
